// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";
// custom CSS styles
import "./src/css/main.css";

const {
  trackWebVitals,
  addGarfield,
  GARFIELD_OBJ_NAME,
  GARFIELD_NAMESPACE,
  GARFIELD_EVENT_NAME,
} = require("./src/utils/garfieldHelper");

export const onRouteUpdate = ({
  location,
  prevLocation,
}) => {
  if (
    !window[GARFIELD_OBJ_NAME] ||
    !prevLocation ||
    prevLocation.href === location.href
  )
    return;

  const pageurl = window?.location?.href;
  trackWebVitals(GARFIELD_EVENT_NAME, pageurl);
};

export const onClientEntry = () => {
  addGarfield();
  if (window[GARFIELD_OBJ_NAME]) {
    window[GARFIELD_OBJ_NAME]("create", {
      id: GARFIELD_NAMESPACE,
    });
    const pageurl = window?.location?.href;
    trackWebVitals(GARFIELD_EVENT_NAME, pageurl);
  }
};
